'use client';

import dynamic from 'next/dynamic';

/**
 * -----------------------------------------------------------------------------
 * Allows for the public facing pages to switch between themes.
 *
 * - We are loading this dynamically to prevent server side rendering it on when
 * the app has not loaded the tenant id yet, causing hydration errors in the browser.
 */
export const SimpleThemeToggle = dynamic(() => import('./SimpleThemeToggle'), {
  ssr: false,
});

SimpleThemeToggle.displayName = 'SimpleThemeToggle';
